import * as yup from "yup";

const CompanySchema = yup.object().shape({
  id: yup.string().required(),
  name: yup.string().required(),
});

export default CompanySchema;
